<template>
    <div class="bg-light container-height ">

        <div class="p-2">

            <div class="d-flex flex-row">

                <Container orientation="horizontal"
                           @drop="onColumnDrop($event)"
                           drag-handle-selector=".column-drag-handle"
                           :get-child-payload="getListPayload"
                           :drop-placeholder="upperDropPlaceholderOptions">

                    <Draggable v-for="group in groupValues" :key="group.id">

                    <span class="ms-1 mt-2 badge bg-secondary column-drag-handle move"
                          :style="'background-color: ' + group.color + ' !important;'">{{group.id}}</span>

                        <div class="kanban-list mt-1 me-3">

                            <Container group-name="col"
                                       @drop="(e) => onCardDrop(group.id, e)"
                                       :get-child-payload="getCardPayload(group.id)"
                                       drag-class="card-ghost"
                                       drop-class="card-ghost-drop"
                                       class="h-100"
                                       :drop-placeholder="dropPlaceholderOptions">

                                <Draggable v-for="item in getRecords(group.id)" :key="item[primaryField.index]">
                                    <div class="card my-1 move rounded-0 shadow-sm">
                                        <div class="card-body">
                                            <p class="card-text pointer">
                                                <a href="javascript:void(0)" @click="onCardClick(item)"
                                                   class="text-dark no-underline">
                                                    <strong>{{item[primaryField.index]}}</strong>
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </Draggable>

                            </Container>

                        </div>

                        <div @click="onNewClick(group)" class="ms-1 pointer text-primary">
                            <i class="fad fa-plus-circle"></i> new
                        </div>

                    </Draggable>

                </Container>

            </div>

            <form-modal v-if="showFormModal" @noEvent="showFormModal = false" :table="table" :document="currentDocument"
                        :yesEvent="onDocumentSave"></form-modal>
        </div>

    </div>
</template>

<script>
    import TableUtil from "../../utils/TableUtil";
    import ArrayUtil from "../../utils/ArrayUtil";
    import ViewService from "../../services/ViewService";
    import ViewHeader from "../ViewHeader.vue";
    import {Container, Draggable} from "vue3-smooth-dnd"
    // import Container from "../../components/draganddrop/components/Container";
    // import Draggable from "../../components/draganddrop/components/Draggable";
    import {applyDrag} from "../../utils/DragUtils"
    import DataService from "../../services/DataService";
    import FormModal from "../form/FormModal.vue";
    import ViewUtil from "../../utils/ViewUtil";

    export default {
        name: 'KanbanBoard',
        components: {FormModal, ViewHeader, Container, Draggable},
        props: ['table', 'view', 'showHeader', 'parentTable', 'parentDocument'],
        computed: {
            parentDocumentId() {
                return this.parentDocument ? this.parentDocument['id'] : null
            },
            primaryField() {
                let tableUtil = new TableUtil()
                return tableUtil.getPrimaryField(this.table)
            },
            gridRows() {
                let arrayUtil = new ArrayUtil()
                return arrayUtil.listToGrid(this.records, 4)
            }
        },
        data() {
            return {
                showRecordModal: false,
                currentRecord: null,
                service: new DataService(this.table.id),
                viewUtil: new ViewUtil(this.table, this.view),
                viewService: new ViewService(),
                groupField: null,
                groupValues: [],
                records: [],
                currentGroup: null,
                currentDocument: null,
                upperDropPlaceholderOptions: {
                    className: 'cards-drop-preview',
                    animationDuration: '150',
                    showOnTop: true
                },
                dropPlaceholderOptions: {
                    className: 'drop-preview',
                    animationDuration: '150',
                    showOnTop: true
                },
                showFormModal: false,
                onDocumentSave: function () {
                }
            }
        },
        mounted() {
            this.groupField = this.table.fields.filter(field => (field.index === this.view.group_field_id))[0]

            // if (this.view.layout.groupValues) {
            //     this.groupValues = this.view.layout.groupValues
            // } else {
            for (let i = 0; i < this.groupField.metadata.length; i++) {
                let metadata = this.groupField.metadata[i]
                let groupValue = metadata['value']
                let colorValue = metadata['color']
                this.groupValues.push({id: groupValue, index: i, color: colorValue})
            }

            // Question: should we also support displaying a list with "No Category" if a record is not assigned a group field value?
            this.saveView()
            // }


            this.loadData()
            webase.eventDispatcher.on('viewUpdated', this.loadData)
        },
        beforeUnmount() {
            webase.eventDispatcher.off('viewUpdated', this.loadData)
        },
        methods: {
            onNewClick(group) {
                this.currentGroup = group
                let tableUtil = new TableUtil()
                this.currentDocument = tableUtil.createRecord(this.table)
                this.currentDocument[this.groupField.index] = group.id

                if (this.viewUtil.hasLinkedObjectFilter()) {
                    this.viewUtil.setLinkedObjectFilterData(this.currentDocument, this.openFormModal)
                    return
                }

                this.openFormModal()
            },
            openFormModal() {
                this.showFormModal = true

                this.onDocumentSave = () => {
                    let currentGroupList = this.getRecords(this.currentGroup.id)
                    currentGroupList.push(this.currentDocument)
                    this.service.save(this.currentDocument)
                }
            },
            loadData() {
                console.log('Kanban board load data')
                let viewService = new ViewService()

                viewService.getData(this.view, this.table, this.parentDocumentId).then((response) => {
                    this.records = response
                }).catch((message) => {
                    console.log('error loading data from table')
                    console.log(message)
                })
            },
            saveView() {
                // TODO: we should only do this if it is the owner
                this.view.layout.groupValues = []

                for (let i = 0; i < this.groupValues.length; i++) {
                    let groupData = this.groupValues[i]
                    this.view.layout.groupValues.push({id: groupData.id, index: i})
                }

                let request = {
                    view: {
                        layout: this.view.layout
                    }
                }

                this.viewService.update(this.view.id, request).catch((message) => {
                    console.log('error updating view')
                    console.log(message)
                })
            },
            saveCardOrder(documents) {

                for (let i = 0; i < documents.length; i++) {
                    let document = documents[i]

                    if (document['id']) {

                        if (document['id']['$oid']) {
                            document['id'] = document['id']['$oid']
                        }

                        document['index'] = i
                        this.service.save(document)
                    }
                }
            },
            onCardClick(record) {
                this.currentDocument = record
                this.showFormModal = true

                this.onDocumentSave = () => {
                    this.service.save(this.currentDocument)
                }
            },

            onColumnDrop(dropResult) {
                this.groupValues = applyDrag(this.groupValues, dropResult)
                this.saveView()

            },
            onCardDrop(columnId, dropResult) {
                if (dropResult.removedIndex === null && dropResult.addedIndex === null) {
                    return
                }

                let document = dropResult.payload
                const column = this.findOrCreateGroup(columnId)

                if (dropResult.removedIndex !== null) {
                    column.records.splice(dropResult.removedIndex, 1)
                }

                if (dropResult.addedIndex !== null) {

                    column.records.splice(dropResult.addedIndex, 0, document)
                    document[this.view.group_field_id] = columnId

                    if (document['id']) {

                        if (document['id']['$oid']) {
                            document['id'] = document['id']['$oid']
                        }

                        this.service.save(document)
                    }

                    this.saveCardOrder(column.records)
                }
            },
            getListPayload(index) {
                return this.groupValues[index]
            },
            getCardPayload(groupId) {
                return index => {
                    return this.records.filter(p => p.id === groupId)[0].records[index]
                }
            },

            log(...params) {
                console.log(...params)
            },

            getRecords(groupId) {
                for (let i = 0; i < this.records.length; i++) {
                    let groupData = this.records[i]

                    if (groupData.id === groupId) {
                        return groupData.records
                    }
                }

                return []
            },

            findOrCreateGroup(groupId) {
                for (let i = 0; i < this.records.length; i++) {
                    let groupData = this.records[i]

                    if (groupData.id === groupId) {
                        return groupData
                    }
                }

                let newGroupData = {
                    id: groupId,
                    records: []
                }

                this.records.push(newGroupData)
                return newGroupData
            }
        }
    }
</script>
